import { Card, Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { BackButtonWithinForm } from "~/pages/Compliance/CaseDetailsDrawer/Profiles/OwnersAndControllersCard/CreateOwnersAndControllersFullscreenTakeover/BackButtonWithinForm";
import { dividerStyle, optionRowStyle, sectionLabelStyle } from "./styles_vanilla.css";

type AccountTypeOption = {
  label: string;
  onClick: () => void;
  testId: string;
};

interface Props {
  heading: string;
  title: string;
  backLabel: string;
  onBack: () => void;
  onSelectEntity: () => void;
  onSelectJoint?: () => void;
  onSelectIndividual: () => void;
}

const ProfileCategorySelector = ({
  heading,
  title,
  backLabel,
  onBack,
  onSelectEntity,
  onSelectJoint,
  onSelectIndividual,
}: Props) => {
  const options: AccountTypeOption[] = [
    { label: "Entity", onClick: onSelectEntity, testId: "account-type-entity" },
    ...(onSelectJoint
      ? [{ label: "Joint ownership", onClick: onSelectJoint, testId: "account-type-joint" }]
      : []),
    { label: "Individual", onClick: onSelectIndividual, testId: "account-type-individual" },
  ];

  return (
    <Card>
      <BackButtonWithinForm onClick={onBack} displayText={backLabel} />
      <Text variant="h3" marginBottom="sm">
        {heading}
      </Text>
      <Text className={sectionLabelStyle}>{title}</Text>
      {options.map((option, index) => (
        <div key={option.label}>
          <button
            className={optionRowStyle}
            data-testid={option.testId}
            onClick={option.onClick}
            type="button"
          >
            <Flex alignItems="center" justifyContent="space-between">
              <Text asSpan variant="strong-lg">
                {option.label}
              </Text>
              <Icon
                type="chevron-right"
                color={Colors.Neutral600}
                variant="outline"
                size="large"
              />
            </Flex>
          </button>
          {index < options.length - 1 && <div className={dividerStyle} />}
        </div>
      ))}
    </Card>
  );
};

export default ProfileCategorySelector;
